import actions from './actions';

const state = {};

export default {
  state,
  actions
};
